import React, {
  Component,
  Fragment,
  useState,
  useEffect,
  useContext,
} from "react";
import PropTypes from "prop-types";
import { withStyles } from '@mui/styles'
import { CircularProgress } from '@mui/material';
import { compose } from "recompose";
import styles from "../styles";
import "./styles.scss";
import { Dashboard as DashboardLayout } from "layouts";
import { withSnackbar } from "notistack";
import { Portlet, PortletContent } from 'components';
import { PortletHeader } from "components";
import classNames from "classnames";
import { GetAreaPropHighlights } from "services/others";
import Base from "common/constants";
import {
  GetStateStorage,
  GetNavbarDataFromStorage,
  IsValidSessionSwitch,
} from "common/storage";

import moment from "moment";
import { GetPmaAdminDataAPI } from "services/agent";
import { showErrorNotification } from "common/helpers";
import { showSuccessNotification } from "common/helpers";
// import LinearProgress from "@mui/material/LinearProgress";
import { Store } from "Store";
import DocumentTitle from "react-document-title";
import { Link } from "react-router-dom";
import { propertyUtil } from "views/Pma/PropertyUtil";
import { withRouter } from "common/utils/router.util";
const ExistingQuadrants = (props) => {
  const {
    classes,
    selectedCheckbox,
    handleSelectedCheckbox,
    handleNext,
    forTeams,
    handleForTeams,
    handleDefaultOptional,
    defaultOptional,
  } = props;
  const { dispatch } = useContext(Store);
  //session related variables
  const isAValidSessionSwitch = IsValidSessionSwitch();
  const { userData } = GetStateStorage();

  /**loading variables */
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  return (
    <div className="first-page">
      <div className="screen-number">2nd Step</div>
      <div className="checkbox-container">
        <div className="checkbox-row" onClick={() => handleForTeams(false)}>
          <input
            type="checkbox"
            id="individual-quadrant"
            name="individual-quadrant"
            checked={forTeams === false}
          />
          <label htmlFor="individual-quadrant">
            This Quadrant is for <strong>Individual Agents</strong>
          </label>
        </div>
        <div className="checkbox-row" onClick={() => handleForTeams(true)}>
          <input
            type="checkbox"
            id="team-quadrant"
            name="team-quadrant"
            checked={forTeams === true}
          />
          <label htmlFor="team-quadrant">
            This Quadrant is for <strong>Teams</strong>
          </label>
        </div>
      </div>
      <div className="checkbox-divider"></div>
      <div className="checkbox-container">
        <div
          className="checkbox-row"
          onClick={() => handleDefaultOptional("default")}
        >
          <input
            type="checkbox"
            id="default-quadrant"
            name="default-quadrant"
            checked={defaultOptional === "default"}
          />
          <label htmlFor="default-quadrant">
            This is a <strong>Default</strong> Quadrant/Page
          </label>
        </div>

        <div
          className="checkbox-row"
          onClick={() => handleDefaultOptional("optional")}
        >
          <input
            type="checkbox"
            id="optional-quadrant"
            name="optional-quadrant"
            checked={defaultOptional === "optional"}
          />
          <label htmlFor="optional-quadrant">
            This is an <strong>Optional</strong> Quadrant/Page
          </label>
        </div>
      </div>
      <div className="button-container">
        <div className="cancel-btn">
          <div>Cancel</div>
        </div>
        <div
          className={`next-btn ${
            forTeams !== "" && defaultOptional !== "" && "highlighted-btn"
          }`}
          onClick={() =>
            handleNext({ type: "quadrant", page: "existing quadrant" })
          }
        >
          <div>Next</div>
        </div>
      </div>
    </div>
  );
};

ExistingQuadrants.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default compose(
  withSnackbar,
  withStyles(styles),
  withRouter
)(ExistingQuadrants);
